class CostieraStackAdd extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-stack-add]');
    this.feedback = this.querySelector('[data-stack-feedback]');
    this.ids = (this.dataset.variantIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    if (this.button) {
      this.button.addEventListener('click', () => this.addStack());
    }
  }

  async addStack() {
    if (!this.ids.length || this.adding) return;
    this.adding = true;
    this.button.setAttribute('disabled', '');
    if (this.feedback) this.feedback.textContent = 'Adding…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: this.ids.map((id) => ({ id: Number(id), quantity: 1 })),
        }),
      });

      if (!response.ok) throw new Error('Add to cart failed');

      if (this.feedback) this.feedback.textContent = 'Added to your cart →';
      // Best-effort: let the theme know the cart changed, then show the cart.
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      window.location.href = '/cart';
    } catch (error) {
      if (this.feedback) {
        this.feedback.textContent = 'Sorry — something went wrong. Please try again.';
      }
      this.button.removeAttribute('disabled');
      this.adding = false;
    }
  }
}

if (!customElements.get('costiera-stack-add')) {
  customElements.define('costiera-stack-add', CostieraStackAdd);
}
